import { render } from "./App.vue?vue&type=template&id=5ce0dad2"
import script from "./App.ts?vue&type=script&lang=ts"
export * from "./App.ts?vue&type=script&lang=ts"
script.render = render

export default script